// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3lrMU","item":"PaymentsMobile_item__1zt-B","label":"PaymentsMobile_label__LiWMU","amount":"PaymentsMobile_amount__1Ckj5"};